import { BASE_URL } from '../constants'
import { token } from '../../localStorage'

// ─── Master ──────────────────────────────────────────────────────────────────

export const createCourse = async ({
  title,
  description,
  essential,
  typeCourseId = null,
  classUrl,
}) => {
  const URL = `${BASE_URL}courses/create`
  const rawBody = JSON.stringify({
    title,
    description,
    essential,
    typeCourseId,
    classUrl,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateCourse = async ({
  courseId,
  title,
  description,
  essential,
  typeCourseId = null,
  active,
  classUrl,
}) => {
  const URL = `${BASE_URL}courses/update`
  const rawBody = JSON.stringify({
    courseId,
    title,
    description,
    essential,
    typeCourseId,
    active,
    classUrl,
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const uploadCourseVideo = async ({
  video,
  pdf,
  courseId,
  title,
  description,
  position,
  previewSeconds,
  previewStart,
  previewHeight,
}) => {
  const URL = `${BASE_URL}courses/video/upload`

  const formData = new FormData()
  const file = video instanceof FileList ? video[0] : video
  formData.append('video', file)
  if (pdf) {
    const pdfFile = pdf instanceof FileList ? pdf[0] : pdf
    formData.append('pdf', pdfFile)
  }
  formData.append('courseId', courseId)
  formData.append('title', title)
  formData.append('description', description)
  formData.append('position', position)
  formData.append('previewSeconds', previewSeconds)
  formData.append('previewStart', previewStart)
  formData.append('previewHeight', previewHeight)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateCourseVideo = async ({
  video,
  pdf,
  videoId,
  courseId,
  title,
  description,
  position,
  previewSeconds,
  previewStart,
  previewHeight,
}) => {
  const URL = `${BASE_URL}courses/video/update`

  const formData = new FormData()
  if (video) {
    const file = video instanceof FileList ? video[0] : video
    formData.append('video', file)
  }
  if (pdf) {
    const pdfFile = pdf instanceof FileList ? pdf[0] : pdf
    formData.append('pdf', pdfFile)
  }
  formData.append('videoId', videoId)
  formData.append('courseId', courseId)
  formData.append('title', title)
  formData.append('description', description)
  formData.append('position', position)
  formData.append('previewSeconds', previewSeconds)
  formData.append('previewStart', previewStart)
  formData.append('previewHeight', previewHeight)

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const deleteCourse = async ({ courseId }) => {
  const URL = `${BASE_URL}courses/delete?courseId=${courseId}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const deleteCourseVideo = async ({ videoId }) => {
  const URL = `${BASE_URL}courses/video/delete?videoId=${videoId}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const createCourseQuestion = async ({ courseId, question, options }) => {
  const URL = `${BASE_URL}courses/question/create`
  const rawBody = JSON.stringify({
    courseId,
    question,
    options,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const updateCourseQuestion = async ({
  questionId,
  question,
  active,
  options,
}) => {
  const URL = `${BASE_URL}courses/question/update`
  const rawBody = JSON.stringify({
    questionId,
    question,
    active,
    options,
  })

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const deleteCourseQuestion = async ({ questionId }) => {
  const URL = `${BASE_URL}courses/question/delete?questionId=${questionId}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getQuestionProgressByTalent = async (talentId) => {
  const URL = `${BASE_URL}courses/question/progress/byTalent?talentId=${talentId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

// ─── Master y talento ────────────────────────────────────────────────────────

export const getCoursesList = async () => {
  const URL = `${BASE_URL}courses/list`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCourseOne = async (courseId) => {
  const URL = `${BASE_URL}courses/one?courseId=${courseId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getVideosByCourse = async (courseId) => {
  const URL = `${BASE_URL}courses/videos/listByCourse?courseId=${courseId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCourseVideoOne = async (videoId) => {
  const URL = `${BASE_URL}courses/video/one?videoId=${videoId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getCourseQuestionOne = async (questionId) => {
  const URL = `${BASE_URL}courses/question/one?questionId=${questionId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getQuestionsByCourse = async (courseId) => {
  const URL = `${BASE_URL}courses/questions/listByCourse?courseId=${courseId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

// ─── Solo talento ────────────────────────────────────────────────────────────

export const completeCourseVideo = async ({ talentId, videoId }) => {
  const URL = `${BASE_URL}courses/talent/completeVideo`
  const rawBody = JSON.stringify({
    talentId,
    videoId,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getWatchedCourses = async () => {
  const URL = `${BASE_URL}courses/talent/listWatched`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getTalentCourseOne = async (courseId) => {
  const URL = `${BASE_URL}courses/talent/one?courseId=${courseId}`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const sendTalentQuestionAnswers = async ({ answers }) => {
  const URL = `${BASE_URL}courses/talent/question/answers`
  const rawBody = JSON.stringify({
    answers,
  })

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}

export const getTalentQuestionProgress = async () => {
  const URL = `${BASE_URL}courses/talent/question/progress`

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    const res = await response.json()
    return {
      response,
      res,
    }
  } catch (error) {
    console.log(error)
  }
}
